import { LoadingIndicator, Sizes } from '@chr/navisphereonline-shared-components';
import { IAppState } from '@/app-state';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PermissionIds } from '@chr/online-shared-ui-constants';
import { LoadingStatuses } from './common/constants/enums';
import { getUserAccessPolicies } from './common/userAccessPolicy/actions';
import { getUserProfile } from './common/userProfile/actions';
import { userHasPermission } from './common/user-helpers';
import { RedirectToPageNotFound } from './common/util/redirectToPageNotFound';

export function AppLoader({children}) {
  const dispatch = useDispatch();
  const userAccessPolicies = useSelector((state: IAppState) => state.userAccessPolicyState.userAccessPolicies);
  const profileLoading = useSelector((state: IAppState) => LoadingStatuses.includes(state.userProfileState.status));
  const accessPolicyLoading = useSelector((state: IAppState) => LoadingStatuses.includes(state.userAccessPolicyState.status));

  const hasPermission = useMemo(() => (
    userHasPermission(PermissionIds.PURCHASE_ORDER_CONFIRMATION_BUYER, userAccessPolicies)
      || userHasPermission(PermissionIds.PURCHASE_ORDER_CONFIRMATION_SUPPLIER, userAccessPolicies)
  ), [userAccessPolicies]);

  useEffect(() => {
    dispatch(getUserProfile());
    dispatch(getUserAccessPolicies());
  }, [dispatch]);

  if (profileLoading || accessPolicyLoading) {
    return <LoadingIndicator size={Sizes.Large} />;
  }

  return hasPermission ? children : RedirectToPageNotFound();
}
